import axios from 'axios';
import store from '../../store/index';

export default {
	list() {
		return axios.get(`/api/apikeys?deleted=true`);
	},
	create(apikey) {
		return axios.post(`/api/apikeys`, { name: apikey.name, comment: apikey.comment, permissions: apikey.permissions });
	},
	update(apikey) {
		return axios.patch(`/api/apikeys/${apikey.id}`, {
			name: apikey.name,
			comment: apikey.comment,
			permissions: apikey.permissions,
			deleted: apikey.deleted,
		});
	},
	delete(apikeyId) {
		return axios.delete(`/api/apikeys/${apikeyId}`);
	},
};
